import { Link } from 'react-router-dom';

import '../view.css'
import './profile.css'
import profileimage from './profileimg.jpeg'

const calculateAge = (birthDate) => {
    const today = new Date();
    const birthDateObj = new Date(birthDate);
    let age = today.getFullYear() - birthDateObj.getFullYear();
    const monthDifference = today.getMonth() - birthDateObj.getMonth();

    // Adjust age if the current date is before the birth date in the current year
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDateObj.getDate())) {
        age--;
    }

    return age;
};

const AgeComponent = () => {
    const birthDate = '1996-04-29'; // Igor's birth date
    return <span>{calculateAge(birthDate)}</span>;
};

export const Profile = () => (
    <div className='view' id='profileview'>

        <div className="profilecontainer">

            <div className='profilecard'>
                <div className='profilelines'></div>
                <div className='profileimagebox'>
                    <img src={profileimage} alt='Igor Tomich profile' />
                </div>

                <div className='profilecontent'>
                    <div className='profiledetails'>
                        <h2>Igor Tomich <br/></h2>
                        <div className='profiledata'>
                            <h3>Age<br/><AgeComponent /></h3>
                            <h3>Profession<br/><span>Computer Engineer</span></h3>
                        </div>

                        <div className='profileactionbutton'>
                            <Link to="/experience" className='profilebutton'>Skills</Link>
                            <Link to="/contact" className="profilebutton">Contact</Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="profiletextcard">
                <div className='profilelines'></div>
                <div className='profiletext'>
                    Hi there! I'm Igor Lacerda Tomich and I am a technology and engineering enthusiast. I completed my undergraduate degree in computer engineering and my master's degree in computer science, and I will soon be starting my PhD. I have worked in several areas, mainly with web and mobile systems development, IoT architectures, database and networking systems. My hobby is to develop and build my own engineering and technology projects and the main purpose of this site is to show them and share my experience in designing and developing them. Hope you like it!
                </div>
            </div>

        </div>

    </div>
);
